import React, { useEffect, useState, Fragment } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { Modal as mod } from "bootstrap";
import Modal from "react-bootstrap/Modal";
import addbutton from "../../static/images/add-button.png";
import $ from "jquery";
import GaleriaFotos from "../../components/GaleriaFotos";
import GaleriaVideos from "../../components/GaleriaVideos";

const FotosVideos = ({ id, reload, edit }) => {
  const [flag, setflag] = useState(false);
  const [expUpdate, setexpUpdate] = useState("");
  const [deleteExp, setdeleteExp] = useState("");
  const [show, setShow] = useState(false);
  const [listVideos, setlistVideos] = useState([]);
  const [listPhotos, setlistPhotos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [FieldValue, setFieldValue] = useState("");

  useEffect(() => {
    GetData();
    //GetPhotos();
    setLoading(false);
  }, [flag, loading]);

  function GuardarVideo(values) {
    let config = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
      },
    };

    const video = {
      companyId: id,
      companyVideoId: 0,
      description: values.description,
      url: values.url,
    };

    axios
      .post("company-video/create-video", JSON.stringify(video), config)
      .then((result) => {
        if (result.status === 200) {
          toast.success(result.data.message, {
            duration: 4000,
          });
          setLoading(true);
          $("#agregar-video-modal").modal("hide");
          //reload();
        }
      })
      .catch(function (error) {
        $("#agregar-video-modal").modal("hide");
      });
  }

  function GuardarFoto(values) {
    let formData = new FormData();
    formData.append("companyVideoId", 0);
    formData.append("companyId", id);
    formData.append("image", FieldValue);
    formData.append("description", values.description);

    let config = {
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
    };

    axios
      .post("company-video/create-image", formData, config)
      .then((result) => {
        if (result.status === 200) {
          setflag(flag ? false : true);
          toast.success("Foto cargada exitosamente", {
            duration: 6000,
          });
          $("#agregar-foto-modal").modal("hide");
        }
      })
      .catch(function (error) {
        $("#agregar-foto-modal").modal("hide");
      });
  }

  function GetData() {
    axios.get("company-video/list-videos/" + id).then((result) => {
      setlistVideos(result.data.filter((lst) => lst.image === null));
      setlistPhotos(result.data.filter((lst) => lst.image != null));
    });
  }

  const Validaciones = Yup.object().shape({
    url: Yup.string()
      .required("No puede estar vacío")
      .max(1500, "No puede tener más de 60 caracteres"),
    description: Yup.string()
      .required("No puede estar vacío")
      .min(3, "No puede tener menos de 3 caracteres")
      .max(800, "No puede tener mas de 800 caracteres"),
  });

  const titulo = {
    textAlign: "left",
    font: "normal normal 600 18px/27px Poppins",
    letterSpacing: "0px",
    color: "#646464",
    opacity: 1,
    fontSize: "18px",
  };

  return (
    <Fragment>
      <div className="vacancy__description bordered-box vacantes perfil-empresa usuario">
        <div className="row mt-2 mb-4 bordered-box__header">
          <div className="col-10">
            <div className="bordered-box__header-title">Fotos y Videos</div>
          </div>
        </div>
        <div className="bordered-box__header">
          <div className="row mt-2 mb-4">
            <div className="bordered-box__header-title col-10">Videos</div>
            {edit ? (
              <div className="col-2 text-end">
                <a
                  id="stylevideomodal"
                  href="#"
                  data-bs-toggle="modal"
                  data-bs-target="#agregar-video-modal"
                  data-title="Video"
                >
                  <img src={addbutton} alt="Agregar Video"></img>
                </a>
              </div>
            ) : (
              ""
            )}
            {loading ? (
              <label className="login-label">CARGANDO...</label>
            ) : (
              <GaleriaVideos
                data={listVideos}
                reload={GetData}
                edit={edit}
              ></GaleriaVideos>
            )}
          </div>
        </div>
        <div>
          <div className="row mt-2 mb-4">
            <div className="bordered-box__header-title col-10">
              Galería de fotos
            </div>
            {edit ? (
              <div className="col-2 text-end">
                <a
                  href="#"
                  data-bs-toggle="modal"
                  data-bs-target="#agregar-foto-modal"
                  data-title="Fotos"
                >
                  <img src={addbutton} alt="Agregar Fotos"></img>
                </a>
              </div>
            ) : (
              ""
            )}
            {loading ? (
              <label className="login-label">CARGANDO...</label>
            ) : (
              <GaleriaFotos
                data={listPhotos}
                reload={GetData}
                edit={edit}
              ></GaleriaFotos>
            )}
          </div>
        </div>
      </div>
      <div
        id="agregar-video-modal"
        className="kr-modal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title"></div>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <Formik
                initialValues={{
                  description: "",
                  url: "",
                }}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                  setSubmitting(true);
                  GuardarVideo(values);
                  resetForm(true);
                  setSubmitting(false);
                }}
                validationSchema={Validaciones}
              >
                {({ errors, touched, isSubmitting }) => (
                  <Form>
                    <div className="mb-4 row">
                      <label htmlFor="url" className="col-sm-2 pe-0">
                        URL Video:
                      </label>
                      <div className="col-sm-10">
                        <Field
                          id="url"
                          name="url"
                          type="text"
                          required
                          className="form-control form-control-sm"
                        ></Field>
                        {errors.url && touched.url && (
                          <span className="form__validation form__validation--error">
                            {errors.url}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="mb-4 row">
                      <label htmlFor="description" className="col-sm-2 pe-0">
                        Descripción:
                      </label>
                      <div className="col-sm-10">
                        <Field
                          as="textarea"
                          id="description"
                          name="description"
                          //type="textarea"
                          required
                          className="form-control form-control-sm"
                        ></Field>
                        {errors.description && touched.description && (
                          <span className="form__validation form__validation--error">
                            {errors.description}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        data-bs-dismiss="modal"
                        className="btn btn--cancel"
                      >
                        Cancelar
                      </button>
                      <button
                        disabled={isSubmitting}
                        type="submit"
                        className="btn btn--gradient"
                      >
                        Subir
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
      <div
        id="agregar-foto-modal"
        className="kr-modal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title"></div>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <Formik
                initialValues={{
                  description: "",
                  //imageUpdate: ""
                }}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                  setSubmitting(true);
                  GuardarFoto(values);
                  resetForm(true);
                  setSubmitting(false);
                }}
                //validationSchema={Validaciones}
              >
                {({ errors, touched, isSubmitting }) => (
                  <Form>
                    <div className="mb-4 row">
                      <label htmlFor="imageUpdate" className="col-sm-2 pe-0">
                        Seleccione una imagen:
                      </label>
                      <div className="col-sm-10">
                        <input
                          id="imageUpdate"
                          name="imageUpdate"
                          type="file"
                          onChange={(event) => {
                            setFieldValue(event.currentTarget.files[0]);
                          }}
                          required
                        />
                      </div>
                    </div>
                    <div className="mb-4 row">
                      <label htmlFor="description" className="col-sm-2 pe-0">
                        Descripción:
                      </label>
                      <div className="col-sm-10">
                        <Field
                          as="textarea"
                          id="description"
                          name="description"
                          //type="textarea"
                          required
                          className="form-control form-control-sm"
                        ></Field>
                        {errors.description && touched.description && (
                          <span className="form__validation form__validation--error">
                            {errors.description}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        data-bs-dismiss="modal"
                        className="btn btn--cancel"
                      >
                        Cancelar
                      </button>
                      <button
                        disabled={isSubmitting}
                        type="submit"
                        className="btn btn--gradient"
                      >
                        Subir
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default FotosVideos;
